import { getRouteRedirect, type Redirect } from "@/router/redirect";
import { useAccountStore } from "@/store/stores/account";
import type { SearchResult } from "@/types/search_result";

export type Action =
  | Redirect
  | {
      type: "action";
      action: () => void;
      payload: Record<string, string>;
    };

export const createViewAllAction = (term: string): Action => {
  return {
    type: "route",
    route: {
      name: "/search",
      query: {
        // trim leading, trailing and repetitive whitespace
        term: term.replace(/^ +| +$| +(?= )/g, ""),
      },
    },
  };
};

export const generateAction = (result: SearchResult): Action => {
  if (result.type === "special_action") {
    return {
      type: "action",
      action: result.action,
      payload: {},
    };
  } else if (result.type === "newsletter") {
    return {
      type: "action",
      action: () => {
        const accountStore = useAccountStore();

        accountStore.switchNewsletter(result.obj.id);
      },
      payload: {
        newsletter: result.obj.id,
      },
    };
  } else if (result.type === "page") {
    return {
      type: "route",
      route: result.obj,
    };
  } else if (result.type === "external_url") {
    return {
      type: "action",
      action: () => {
        window.open(result.obj.url, "_blank");
      },
      payload: {},
    };
  } else if (result.type === "note") {
    return getRouteRedirect(result.obj.model_type, result.obj.model_id);
  } else if (result.type === "survey_response") {
    return getRouteRedirect("survey", result.obj.survey_id);
  } else {
    return getRouteRedirect(result.type, result.obj.id);
  }
};
